// extracted by mini-css-extract-plugin
export default {"cardsSectionWrapper":"styles_cardsSectionWrapper__txHtX","noAvailability":"styles_noAvailability__acFay"};